import type { Aba, AtendenteDTO, Vez } from '@viniko/shared';
import { MessageCircle } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Vazio } from '../../componentes/ui';
import { Chat } from './Chat';
import { ListaConversas } from './ListaConversas';
import './conversas.css';

export interface FiltrosLista {
  aba: Aba;
  vez: Vez | undefined;
  busca: string;
  atendenteId: string | undefined;
}

export function Conversas({ eu }: { eu: AtendenteDTO }) {
  const { id } = useParams();
  const [filtros, setFiltros] = useState<FiltrosLista>({
    aba: 'minhas',
    vez: undefined,
    busca: '',
    atendenteId: undefined,
  });
  const [buscaAtrasada, setBuscaAtrasada] = useState('');

  useEffect(() => {
    const t = setTimeout(() => setBuscaAtrasada(filtros.busca.trim()), 250);
    return () => clearTimeout(t);
  }, [filtros.busca]);

  return (
    <div className={`conversas ${id ? 'com-chat' : ''}`}>
      <ListaConversas
        eu={eu}
        filtros={filtros}
        busca={buscaAtrasada}
        mudar={(f) => setFiltros((a) => ({ ...a, ...f }))}
      />
      {id ? (
        <Chat key={id} id={id} eu={eu} />
      ) : (
        <main className="chat-vazio">
          <Vazio icone={<MessageCircle className="grande" />} titulo="Selecione uma conversa">
            Em <b>Minhas › Responder</b> ficam as conversas em que o cliente está esperando você. A{' '}
            <b>Fila</b> mostra quem a IA já passou pra atendimento humano.
          </Vazio>
        </main>
      )}
    </div>
  );
}
